// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8.848 5.3568C8.45633 4.73013 7.54367 4.73013 7.152 5.3568L3.95625 10.47C3.53997 11.136 4.01881 12 4.80425 12L11.1958 12C11.9812 12 12.46 11.136 12.0438 10.47L8.848 5.3568Z" />
    </svg>
  );
};
